import React, { useState, useRef, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useAutocomplete } from "@mui/base/useAutocomplete";
import CheckIcon from "@mui/icons-material/Check";
import TextField from "@mui/material/TextField";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import * as StyledDOM from "./AutoComplete.jsx";
import CloseIcon from "../../Assets/Images/Close-icon.svg";
import CloseDarkIcon from "../../Assets/Images/Close-dark-icon.png";
import { DynamicContext } from "../../Context/DynamicContext.js";
import { toCapitalize } from "../Common-Function/CommonFunctions.js";
function LegacyCustomAutocomplete({
  tags,
  text,
  placeholder,
  options = [],
  onChange,
  onBlur = () => {},
  clearTriggered,
  InputWrapperStyle = {},
  containerStyle = {},
  iconStyle = {},
  listBoxStyle = {},
  autocompleteOuterDiv = {},
  customstyle = {},
  showDownArrowIcon = false,
  downArrow = true,
  inputStyle = {},
  error = "",
  fieldLabel = "",
  errorMessage = "",
  labelColor = "#000",
  backgroundColor = "#fff",
  defaultValues = [],
  value: externalValue,
  dataattr,
  required = false,
  showClearAll = false,
  inputReadOnly = false,
  minTags = 0,
  useToCapitalize = false,
  ...props
}) {
  const { isDarkMode } = useContext(DynamicContext);
  const inputWrapperRef = useRef(null);
  const [listBoxWidth, setListBoxWidth] = useState("auto");
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState(defaultValues || []);
  const [open, setOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

   useEffect(() => {
    if (externalValue !== undefined) {
      setValue(externalValue);
    }
  }, [externalValue]);

  useEffect(() => {
    if (props.clearTriggered) {
      setInputValue("");
      setValue([]);
    }
  }, [props.clearTriggered]);

  useEffect(() => {
    if (clearTriggered) {
      setInputValue("");
      setValue([]);
    }
  }, [clearTriggered]);

  useEffect(() => {
    if (inputWrapperRef.current) {
      const width = inputWrapperRef.current.offsetWidth;
      setListBoxWidth(`${width}px`);
    }
    const handleResize = () => {
      if (inputWrapperRef.current) {
        const width = inputWrapperRef.current.offsetWidth;
        setListBoxWidth(`${width}px`);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const generateOptionId = (option) => {
    if (option && option.id) return option.id;
    const title = typeof option === "string" ? option : option.title || "";
    return title.toLowerCase().replace(/\s+/g, "-");
  };

  const handlePaste = (e) => {
    if (!tags) return;
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain");
    const pastedValues = pasteData
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);

    if (pastedValues.length > 0) {
      const newOptions = pastedValues.map((val) => ({
        id: generateOptionId(val),
        title: val,
      }));
      const uniqueValues = [
        ...new Set([
          ...value.map((v) => (typeof v === "string" ? v : v.title)),
          ...newOptions.map((opt) => opt.title),
        ]),
      ];
      const updatedValue = uniqueValues.map((val) => {
        const existingOption =
        (options?.length &&
          options.find(
            (opt) => (typeof opt === "string" ? opt : opt.title) === val
          )) ||
        newOptions.find((opt) => opt.title === val);
        
        // const existingOption =
        //   options.find(
        //     (opt) => (typeof opt === "string" ? opt : opt.title) === val
        //   ) || newOptions.find((opt) => opt.title === val);

        return existingOption || { id: generateOptionId(val), title: val };
      });

      setValue(updatedValue);
      onChange(updatedValue.map((v) => (typeof v === "string" ? v : v.title)));
      setInputValue("");
    }
  };
  const handleClearAll = (e) => {
    e.stopPropagation();
    if (minTags > 0 && value.length > 0) {
      return;
    }
    setValue([]);
    onChange([]);
    setInputValue("");
    if (inputWrapperRef.current) {
      inputWrapperRef.current.querySelector("input").focus();
    }
  };
  const {
    getRootProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: "customized-hook-demo",
    defaultValue: defaultValues,
    multiple: tags,
    options: Array.isArray(options)
    ? options
        .filter((option) => option) 
        .map((option) => ({
          id: generateOptionId(option),
          title: typeof option === "string" ? option : option.title,
        }))
    : [],
    getOptionLabel: (option) => {
      if (typeof option === "string") {
        return option;
      }
      if (option && option.inputValue) {
        return option.inputValue;
      }
      return option && option.title ? option.title : "";
    },
    onInputChange: (_, newInputValue, reason) => {
      if (reason === "input") {
        const filteredInputValue = newInputValue.replace(/[^a-zA-Z,]/g, "");
        if (!tags) {
          setInputValue(filteredInputValue);
        } else {
          setInputValue(filteredInputValue);
        }
      } else {
        setInputValue(newInputValue);
      }
    },
    onChange: (_, newValue) => {
      let finalValue;

      if (typeof newValue === "string") {
        finalValue = newValue.trim() !== "" ? [newValue] : [];
      } else if (Array.isArray(newValue)) {
        finalValue = newValue
          .map((option) => option.title || option)
          .filter((value) => value.trim() !== "");
      } else if (newValue && newValue.inputValue) {
        finalValue = [newValue.inputValue];
      } else if (newValue) {
        finalValue = [newValue.title || newValue];
      } else {
        finalValue = [];
      }
      onChange(finalValue);
      setValue(finalValue);
    },
    value: value,
    filterOptions: (options, params) => {
      const filtered = options.filter(
        (option) =>
          option.title &&
          option.title.toLowerCase().includes(params.inputValue.toLowerCase())
      );

      if (params.inputValue !== "" && props.freeSolo) {
        const existingText = options.some(
          (option) => option.title === params.inputValue
        );
        if (!existingText && /^[a-zA-Z]+$/.test(params.inputValue)) {
          filtered.push({
            inputValue: params.inputValue,
            title: `${params.inputValue}`,
            id: generateOptionId(params.inputValue),
          });
        }
      }

      return filtered;
    },
    selectOnFocus: true,
    clearOnBlur: true,
    handleHomeEndKeys: true,
    open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
    renderOption: (props, option, { selected }) => (
      <li {...props}>
        <span>{option.title}</span>
        {selected && <CheckIcon fontSize="small" style={{ color: "blue" }} />}
      </li>
    ),
    freeSolo: true,
    renderInput: (params) => (
      <TextField {...params} label="Free solo with text demo" />
    ),
  });

  const handleIconClick = () => {
    setAnchorEl(inputWrapperRef.current);
    setOpen(true);
    inputWrapperRef.current.querySelector("input").focus();
  };

  const handleInputFocus = () => {
    setIsFocused(true);
    setOpen(true);
  };

  const handleInputBlur = (event) => {
    setIsFocused(false);
    onBlur(event);
  };

  return (
    <StyledDOM.StyledRoot style={containerStyle}>
      <StyledDOM.StyledAutoCompleteOuterDiv
        {...getRootProps()}
        className="outer-autocomplete"
        style={autocompleteOuterDiv}
      >
        <div style={{ position: "relative" }}>
          <StyledDOM.StyledInputWrapper
            style={{
              ...InputWrapperStyle,
            }}
            ref={inputWrapperRef}
            className={`${focused ? "focused" : ""} styled-scrollbar`}
            labelColor={labelColor}
            backgroundColor={backgroundColor}
            onBlur={handleInputBlur}
          >
            {tags &&
              value.map((option, index) => {
                let label;
                if (typeof option === "string") {
                  label = option;
                } else {
                  label = option.title || "";
                }
                const { key, ...tagProps } = getTagProps({ index });
                const handleTagDelete = (e) => {
                  e.stopPropagation();
                  if (minTags > 0 && value.length <= minTags) {
                    return;
                  }
                  tagProps.onDelete(e);
                  const newValue = [...value];
                  newValue.splice(index, 1);
                  setValue(newValue);
                  onChange(newValue);
                };

                return (
                  <StyledDOM.StyledTag
                    key={key}
                    label={useToCapitalize ? toCapitalize(label) : label}
                    {...tagProps}
                    onDelete={handleTagDelete}
                  />
                );
              })}
            <input
              {...getInputProps()}
              placeholder={
                isFocused || value.length > 0 || inputValue
                  ? ""
                  : `${placeholder}`
              }
              className={value.length > 0 ? "has-value" : ""}
              {...(!tags && { value: inputValue })}
              style={{
                background: "none",
                ...inputStyle,
              }}
              onFocus={handleInputFocus}
              onPaste={handlePaste}
              dataattr={dataattr}
              readOnly={inputReadOnly}
            />
            {required && !isFocused && value.length === 0 && !inputValue && (
              <span className="asterisk">*</span>
            )}

            {showDownArrowIcon && (
              <StyledDOM.StyledArrowDiv onClick={handleIconClick}>
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </StyledDOM.StyledArrowDiv>
            )}
            {showClearAll && value.length > 0 && (
              <StyledDOM.StyledClearAllIcon
                alt="small"
                onClick={handleClearAll}
                src={isDarkMode ? CloseDarkIcon : CloseIcon}
                className="autocomplete-clear-all"
                title="Clear all"
              />
            )}
          </StyledDOM.StyledInputWrapper>
          <StyledDOM.StyledLabel
            isVisible={isFocused || value.length > 0 || inputValue}
            labelColor={labelColor}
            backgroundColor={backgroundColor}
          >
            {fieldLabel}
            {required && <span className="asterisk">*</span>}
          </StyledDOM.StyledLabel>
        </div>
        {error && (
          <StyledDOM.StyledErrorMessage className="error-message">
            {errorMessage}
          </StyledDOM.StyledErrorMessage>
        )}
      </StyledDOM.StyledAutoCompleteOuterDiv>
      {groupedOptions.length > 0 ? (
        <StyledDOM.StyledListbox
          {...getListboxProps()}
          style={{ ...listBoxStyle, width: listBoxWidth }}
          className="autocomplete-listoption"
        >
          {groupedOptions.map((option, index) => {
            const isSelected = Array.isArray(value)
              ? value.includes(option.title)
              : value.title === option.title;
            const optionProps = getOptionProps({ option, index });
            const { key, ...restOptionProps } = optionProps;
            return (
              <StyledDOM.StyledListItem
                key={key}
                {...restOptionProps}
                isSelected={isSelected}
              >
                <span>{option.title}</span>
                {isSelected && (
                  <CheckIcon fontSize="small" style={{ color: "#004b9e" }} />
                )}
              </StyledDOM.StyledListItem>
            );
          })}
        </StyledDOM.StyledListbox>
      ) : null}
    </StyledDOM.StyledRoot>
  );
}

LegacyCustomAutocomplete.propTypes = {
  tags: PropTypes.bool,
  text: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  clearTriggered: PropTypes.bool,
  InputWrapperStyle: PropTypes.object,
  containerStyle: PropTypes.object,
  iconStyle: PropTypes.object,
  listBoxStyle: PropTypes.object,
  autocompleteOuterDiv: PropTypes.object,
  customstyle: PropTypes.object,
  showDownArrowIcon: PropTypes.bool,
  downArrow: PropTypes.bool,
  inputStyle: PropTypes.object,
  error: PropTypes.string,
  fieldLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  labelColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  dataattr: PropTypes.string,
  required: PropTypes.bool,
  defaultValues: PropTypes.array,
  value: PropTypes.array,
  showClearAll: PropTypes.bool,
  inputReadOnly: PropTypes.bool,
  minTags: PropTypes.number,
};

/*CustomAutocomplete.defaultProps = {
  tags: false,
  placeholder: "",
  clearTriggered: false,
  onBlur: () => {},
  required: false,
};*/

function ServerSearchCustomAutocomplete({
  tags,
  text,
  placeholder,
  options = [],
  onChange,
  onBlur = () => {},
  clearTriggered,
  InputWrapperStyle = {},
  containerStyle = {},
  iconStyle = {},
  listBoxStyle = {},
  autocompleteOuterDiv = {},
  customstyle = {},
  showDownArrowIcon = false,
  downArrow = true,
  inputStyle = {},
  error = "",
  fieldLabel = "",
  errorMessage = "",
  labelColor = "#000",
  backgroundColor = "#fff",
  defaultValues = [],
  value: externalValue,
  dataattr,
  required = false,
  showClearAll = false,
  inputReadOnly = false,
  minTags = 0,
  useToCapitalize = false,
  onInputChange: externalOnInputChange,
  serverSearch = false,
  returnObjects = false,
  freeSolo = true,
  ...props
}) {
  const { isDarkMode } = useContext(DynamicContext);
  const inputWrapperRef = useRef(null);
  const [listBoxWidth, setListBoxWidth] = useState("auto");
  const [inputValue, setInputValue] = useState("");
  const [value, setValue] = useState(defaultValues || []);
  const [open, setOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

   useEffect(() => {
    if (externalValue !== undefined) {
      setValue(externalValue);
    }
  }, [externalValue]);

  useEffect(() => {
    if (props.clearTriggered) {
      setInputValue("");
      setValue([]);
    }
  }, [props.clearTriggered]);

  useEffect(() => {
    if (clearTriggered) {
      setInputValue("");
      setValue([]);
    }
  }, [clearTriggered]);

  useEffect(() => {
    if (inputWrapperRef.current) {
      const width = inputWrapperRef.current.offsetWidth;
      setListBoxWidth(`${width}px`);
    }
    const handleResize = () => {
      if (inputWrapperRef.current) {
        const width = inputWrapperRef.current.offsetWidth;
        setListBoxWidth(`${width}px`);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const generateOptionId = (option) => {
    if (option && option.id) return option.id;
    const title = typeof option === "string" ? option : option.title || "";
    return title.toLowerCase().replace(/\s+/g, "-");
  };

  const optionMatches = (selectedOption, option) => {
    if (typeof selectedOption === "string") {
      return selectedOption === option.title;
    }
    if (selectedOption?.id && option?.id) {
      return selectedOption.id === option.id;
    }
    return selectedOption?.title === option.title;
  };

  const normalizeSelectedValue = (selectedOption) => {
    if (typeof selectedOption === "string") {
      const matchedOption = options.find(
        (opt) => (typeof opt === "string" ? opt : opt.title) === selectedOption,
      );
      return (
        matchedOption || {
          id: generateOptionId(selectedOption),
          title: selectedOption,
        }
      );
    }

    return selectedOption;
  };

  const handlePaste = (e) => {
    if (!tags) return;
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain");
    const pastedValues = pasteData
      .split(",")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);

    if (pastedValues.length > 0) {
      const newOptions = pastedValues.map((val) => ({
        id: generateOptionId(val),
        title: val,
      }));
      const uniqueValues = [
        ...new Set([
          ...value.map((v) => (typeof v === "string" ? v : v.title)),
          ...newOptions.map((opt) => opt.title),
        ]),
      ];
      const updatedValue = uniqueValues.map((val) => {
        const existingOption =
        (options?.length &&
          options.find(
            (opt) => (typeof opt === "string" ? opt : opt.title) === val
          )) ||
        newOptions.find((opt) => opt.title === val);
        
        // const existingOption =
        //   options.find(
        //     (opt) => (typeof opt === "string" ? opt : opt.title) === val
        //   ) || newOptions.find((opt) => opt.title === val);

        return existingOption || { id: generateOptionId(val), title: val };
      });

      setValue(updatedValue);
      onChange(
        returnObjects
          ? updatedValue.map(normalizeSelectedValue)
          : updatedValue.map((v) => (typeof v === "string" ? v : v.title)),
      );
      setInputValue("");
    }
  };
  const handleClearAll = (e) => {
    e.stopPropagation();
    if (minTags > 0 && value.length > 0) {
      return;
    }
    setValue([]);
    onChange([]);
    setInputValue("");
    if (inputWrapperRef.current) {
      inputWrapperRef.current.querySelector("input").focus();
    }
  };
  const {
    getRootProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: "customized-hook-demo",
    defaultValue: defaultValues,
    multiple: tags,
    inputValue: inputValue,
    options: Array.isArray(options)
    ? options
        .filter((option) => option) 
        .map((option) => ({
          id: generateOptionId(option),
          title: typeof option === "string" ? option : option.title,
        }))
    : [],
    getOptionLabel: (option) => {
      if (typeof option === "string") {
        return option;
      }
      if (option && option.inputValue) {
        return option.inputValue;
      }
      return option && option.title ? option.title : "";
    },
    isOptionEqualToValue: (option, selectedOption) =>
      optionMatches(selectedOption, option),
    onInputChange: (_, newInputValue, reason) => {
      if (reason === "input") {
        const nextInputValue = serverSearch
          ? newInputValue
          : newInputValue.replace(/[^a-zA-Z,]/g, "");
    
        setInputValue(nextInputValue);
    
        if (externalOnInputChange) {
          externalOnInputChange(nextInputValue, reason);
        }
    
        return;
      }
    
      if (reason === "clear") {
        setInputValue("");
    
        if (externalOnInputChange) {
          externalOnInputChange("", reason);
        }
      }
    },
    onChange: (_, newValue) => {
      let finalValue;

      if (typeof newValue === "string") {
        finalValue =
          newValue.trim() !== ""
            ? returnObjects
              ? [normalizeSelectedValue(newValue)]
              : [newValue]
            : [];
      } else if (Array.isArray(newValue)) {
        finalValue = newValue
          .map((option) =>
            returnObjects
              ? normalizeSelectedValue(option)
              : option.title || option,
          )
          .filter((value) => {
            const label = typeof value === "string" ? value : value.title || "";
            return label.trim() !== "";
          });
      } else if (newValue && newValue.inputValue) {
        finalValue = returnObjects
          ? [normalizeSelectedValue(newValue.inputValue)]
          : [newValue.inputValue];
      } else if (newValue) {
        finalValue = returnObjects
          ? [normalizeSelectedValue(newValue)]
          : [newValue.title || newValue];
      } else {
        finalValue = [];
      }
      onChange(finalValue);
      setValue(finalValue);
      setInputValue("");
    },
    value: value,
    filterOptions: (options, params) => {
      if (serverSearch) {
        return options;
      }

      const filtered = options.filter(
        (option) =>
          option.title &&
          option.title.toLowerCase().includes(params.inputValue.toLowerCase())
      );

      if (params.inputValue !== "" && freeSolo) {
        const existingText = options.some(
          (option) => option.title === params.inputValue
        );
        if (!existingText && /^[a-zA-Z]+$/.test(params.inputValue)) {
          filtered.push({
            inputValue: params.inputValue,
            title: `${params.inputValue}`,
            id: generateOptionId(params.inputValue),
          });
        }
      }

      return filtered;
    },
    selectOnFocus: true,
    clearOnBlur: true,
    handleHomeEndKeys: true,
    open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false),
    renderOption: (props, option, { selected }) => (
      <li {...props}>
        <span>{option.title}</span>
        {selected && <CheckIcon fontSize="small" style={{ color: "blue" }} />}
      </li>
    ),
    freeSolo,
    renderInput: (params) => (
      <TextField {...params} label="Free solo with text demo" />
    ),
  });

  const handleIconClick = () => {
    setAnchorEl(inputWrapperRef.current);
    setOpen(true);
    inputWrapperRef.current.querySelector("input").focus();
  };

  const handleInputFocus = () => {
    setIsFocused(true);
    setOpen(true);
  };

  const handleInputBlur = (event) => {
    setIsFocused(false);
    onBlur(event);
  };

  return (
    <StyledDOM.StyledRoot style={containerStyle}>
      <StyledDOM.StyledAutoCompleteOuterDiv
        {...getRootProps()}
        className="outer-autocomplete"
        style={autocompleteOuterDiv}
      >
        <div style={{ position: "relative" }}>
          <StyledDOM.StyledInputWrapper
            style={{
              ...InputWrapperStyle,
            }}
            ref={inputWrapperRef}
            className={`${focused ? "focused" : ""} styled-scrollbar`}
            labelColor={labelColor}
            backgroundColor={backgroundColor}
            onBlur={handleInputBlur}
          >
            {tags &&
              value.map((option, index) => {
                let label;
                if (typeof option === "string") {
                  label = option;
                } else {
                  label = option.title || "";
                }
                const { key, ...tagProps } = getTagProps({ index });
                const handleTagDelete = (e) => {
                  e.stopPropagation();
                  if (minTags > 0 && value.length <= minTags) {
                    return;
                  }
                  tagProps.onDelete(e);
                  const newValue = [...value];
                  newValue.splice(index, 1);
                  setValue(newValue);
                  onChange(newValue);
                };

                return (
                  <StyledDOM.StyledTag
                    key={key}
                    label={useToCapitalize ? toCapitalize(label) : label}
                    {...tagProps}
                    onDelete={handleTagDelete}
                  />
                );
              })}
            <input
              {...getInputProps()}
              placeholder={
                isFocused || value.length > 0 || inputValue
                  ? ""
                  : `${placeholder}`
              }
              className={value.length > 0 ? "has-value" : ""}
              {...(!tags && { value: inputValue })}
              style={{
                background: "none",
                ...inputStyle,
              }}
              onFocus={handleInputFocus}
              onPaste={handlePaste}
              dataattr={dataattr}
              readOnly={inputReadOnly}
            />
            {required && !isFocused && value.length === 0 && !inputValue && (
              <span className="asterisk">*</span>
            )}

            {showDownArrowIcon && (
              <StyledDOM.StyledArrowDiv onClick={handleIconClick}>
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </StyledDOM.StyledArrowDiv>
            )}
            {showClearAll && value.length > 0 && (
              <StyledDOM.StyledClearAllIcon
                alt="small"
                onClick={handleClearAll}
                src={isDarkMode ? CloseDarkIcon : CloseIcon}
                className="autocomplete-clear-all"
                title="Clear all"
              />
            )}
          </StyledDOM.StyledInputWrapper>
          <StyledDOM.StyledLabel
            isVisible={isFocused || value.length > 0 || inputValue}
            labelColor={labelColor}
            backgroundColor={backgroundColor}
          >
            {fieldLabel}
            {required && <span className="asterisk">*</span>}
          </StyledDOM.StyledLabel>
        </div>
        {error && (
          <StyledDOM.StyledErrorMessage className="error-message">
            {errorMessage}
          </StyledDOM.StyledErrorMessage>
        )}
      </StyledDOM.StyledAutoCompleteOuterDiv>
      {groupedOptions.length > 0 ? (
        <StyledDOM.StyledListbox
          {...getListboxProps()}
          style={{ ...listBoxStyle, width: listBoxWidth }}
          className="autocomplete-listoption"
        >
          {groupedOptions.map((option, index) => {
            const isSelected = Array.isArray(value)
            ? value.some((selectedOption) =>
                optionMatches(selectedOption, option),
              )
            : optionMatches(value, option);
            const optionProps = getOptionProps({ option, index });
            const { key, ...restOptionProps } = optionProps;
            return (
              <StyledDOM.StyledListItem
                key={key}
                {...restOptionProps}
                isSelected={isSelected}
              >
                <span>{option.title}</span>
                {isSelected && (
                  <CheckIcon fontSize="small" style={{ color: "#004b9e" }} />
                )}
              </StyledDOM.StyledListItem>
            );
          })}
        </StyledDOM.StyledListbox>
      ) : null}
    </StyledDOM.StyledRoot>
  );
}

ServerSearchCustomAutocomplete.propTypes = {
  tags: PropTypes.bool,
  text: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  clearTriggered: PropTypes.bool,
  InputWrapperStyle: PropTypes.object,
  containerStyle: PropTypes.object,
  iconStyle: PropTypes.object,
  listBoxStyle: PropTypes.object,
  autocompleteOuterDiv: PropTypes.object,
  customstyle: PropTypes.object,
  showDownArrowIcon: PropTypes.bool,
  downArrow: PropTypes.bool,
  inputStyle: PropTypes.object,
  error: PropTypes.string,
  fieldLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  labelColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  dataattr: PropTypes.string,
  required: PropTypes.bool,
  defaultValues: PropTypes.array,
  value: PropTypes.array,
  showClearAll: PropTypes.bool,
  inputReadOnly: PropTypes.bool,
  minTags: PropTypes.number,
  onInputChange: PropTypes.func,
  serverSearch: PropTypes.bool,
  returnObjects: PropTypes.bool,
  freeSolo: PropTypes.bool,
};

export default function CustomAutocomplete(props) {
  return props.serverSearch === true ? (
    <ServerSearchCustomAutocomplete {...props} />
  ) : (
    <LegacyCustomAutocomplete {...props} />
  );
}